import { Combobox, DatePicker, Errors, Field, RadioboxGroup, SimpleRadiobox, TextInput, WithForm, validation } from '@startlibs/form';
import {Dialog, Button, SplitColumnsContainer, ConfirmDialog, Loading} from '@startlibs/components'
import {formFetch, formatDate, getColor, getFetcher, postFetcher} from '@startlibs/utils'
import React, { useEffect, useState } from 'react'
import _ from 'lodash/fp'

import {useNotificationRef} from '../../components/Notifications'
import styled from 'styled-components';
import { InfoBox } from '../../components/InfoBox';
import { CardHeader } from '../errors/ProviderError';

const ErrorCard = styled.div`
  padding: 2.5rem;
  background: white;
  border-radius: 8px;
  max-width: 40rem;
  margin: 0 auto;
  p {
    font-size: 14px;
  }
`

const FlexDiv = styled.div`
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
`

const LoadingDiv = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  /* align-content: center; */
  justify-content: center;
  align-items: center;
  height: 200px;
`

const TagEditorInfoBox = styled(InfoBox)`
  background: #EFF4F7;
  border: none;
  padding: 1rem;
  color: ${getColor('gray60')};
  margin: -0.25rem 0 1rem;
`

export const checknames = () => (item, k, props) => 
  (_.get('firstName',props).length + _.get('middleName',props).length + _.get('lastName',props).length) > 60 && 'Name must be less than 60 characters.';

export const atLeastOneName = () => (item, k, props) =>
  (_.get('firstName',props).length + _.get('middleName',props).length + _.get('lastName',props).length) < 1 && 'At least one name is required.';

export const checkGender = () => (item, k, props) => 
  (_.get('patientSex',props) !="M" && _.get('patientSex',props) !="F" ) && 'Field is required';
  
const preValidation = validation.buildValidation({
  patientID:[validation.required, (v) => v?.length > 64 && "Patient ID must be shorter than 64 characters"],
  // firstName: [validation.required, checknames(), (v) => v?.length < 2 && "First name must be at least 2 characters long."],
  // middleName:[checknames()],
  // lastName:[validation.required, checknames(), (v) => v?.length < 2 && "Last name must be at least 2 characters long."],
  firstName: [atLeastOneName(), checknames()],
  middleName:[atLeastOneName(), checknames()],
  lastName:[atLeastOneName(), checknames()],
  patientSex:[validation.required, checkGender()],
  institutionName:[(v) => v?.length > 64 && "Institution name must be shorter than 64 characters"],
})

const DATE_FORMAT = "yyyy-MM-dd"
const TRANSFORM_DATE_FORMAT = "yyyyMMdd"


const name1 = "do Nascimento^Gabriel^Monteiro";
// const name1 = "Adams^John Robert Quincy^^Rev.^B.A. M.Div.";
// 0: "Adams" // Family Name
// 1: "John Robert Quincy" // Given Name
// 2: "" // Middle Name
// 3: "Rev." // Prefix
// 4: "B.A. M.Div." // Suffix

const buildName = (nameObject) => {
  const nameArray = [
    nameObject?.lastName,
    nameObject?.firstName,
    nameObject?.middleName,
    nameObject?.prefix,
    nameObject?.suffix,
  ]
  const nameString = nameArray.join("^")
  return nameString
}

const splitName = (name) => {
  const nameArray = name.split("^")
  const nameObject = {
    lastName: nameArray[0],
    firstName: nameArray[1],
    middleName: nameArray[2],
    prefix: nameArray[3],
    suffix: nameArray[4],
  }
  return nameObject
}

const transform = (values, originalPatientData) => {

  const name = buildName(values)
  const dob = formatDate(values.patientDOB,TRANSFORM_DATE_FORMAT)

  return {
    form: values,
    updatedTags: [
      values.patientID !== originalPatientData.patientID && {"tagID" : "0010,0020", "tagValue" : values.patientID},
      name !== originalPatientData.patientName && {"tagID" : "0010,0010", "tagValue" : name},
      dob !== originalPatientData.patientDOB && {"tagID" : "0010,0030", "tagValue" : dob},
      values.patientSex !== originalPatientData.patientSex && {"tagID" : "0010,0040", "tagValue" : values.patientSex},
      values.institutionName !== originalPatientData.institutionName && {"tagID" : "0008,0080", "tagValue" : values.institutionName},
      values.study_desc !== originalPatientData.study_desc && {"tagID" : "0008,1030", "tagValue" : values.study_desc},
      values.ref_phy !== originalPatientData.ref_phy?.replace(/\^/g, ' ').trim() && {"tagID" : "0008,0090", "tagValue" : buildName({lastName: values.ref_phy})},
    ].filter(Boolean)
  }
}

const updateAndClose = (form, originalPatientData, studyUid, study, setStudy, closeDialog, setNotification, setIsSubmitting) => {
  setIsSubmitting(true)
  const updatedTags = transform(form.getValues(), originalPatientData).updatedTags 
  var logContent = {
    patientPK: originalPatientData?.patientPK,
    countStudies: originalPatientData.countStudies,
    patientName: updatedTags.find(tag => tag.tagID === "0010,0010")?.tagValue && originalPatientData.patientName, 
    newPatientName: updatedTags.find(tag => tag.tagID === "0010,0010")?.tagValue,
    patientID: originalPatientData.patientID !== form.getValues().patientID && originalPatientData.patientID,
    newPatiendID: originalPatientData.patientID !== form.getValues().patientID && updatedTags.find(tag => tag.tagID === "0010,0020")?.tagValue,
    patientDOB: updatedTags.find(tag => tag.tagID === "0010,0030")?.tagValue.length >= 0 && originalPatientData.patientDOB,
    newPatientDOB: originalPatientData.patientDOB !== form.getValues().patientDOB && updatedTags.find(tag => tag.tagID === "0010,0030")?.tagValue,
    patientSex:   originalPatientData.patientSex !== form.getValues().patientSex && originalPatientData.patientSex,
    newPatientSex:  originalPatientData.patientSex !== form.getValues().patientSex && updatedTags.find(tag => tag.tagID === "0010,0040")?.tagValue,
    institutionName: originalPatientData.institutionName !== form.getValues().institutionName && originalPatientData.institutionName,
    newInstitutionName: originalPatientData.institutionName !== form.getValues().institutionName && updatedTags.find(tag => tag.tagID === "0008,0080")?.tagValue,
    studyDescription: originalPatientData?.study_desc !== form.getValues().study_desc && originalPatientData.study_desc,
    newStudyDescription: originalPatientData?.study_desc !== form.getValues().study_desc && updatedTags.find(tag => tag.tagID === "0008,1030")?.tagValue,
    referringPhysicianName: originalPatientData?.ref_phy?.replace(/\^/g, ' ').trim() !== form.getValues().ref_phy && originalPatientData?.ref_phy?.replace(/\^/g, ' '),
    newReferringPhysicianName: originalPatientData?.ref_phy?.replace(/\^/g, ' ').trim() !== form.getValues().ref_phy && form.getValues().ref_phy
  }

  // remove empty values from logContent
  Object.keys(logContent).forEach(key => (logContent[key] === undefined || logContent[key] === false)  && delete logContent[key])
  
  // adding all the formated values to single json object
  var jsonParams =
  {
    study_iuid :  studyUid,
    patientID: updatedTags.find(tag => tag.tagID === "0010,0020")?.tagValue 
      ? updatedTags.find(tag => tag.tagID === "0010,0020")?.tagValue 
      : originalPatientData.patientID,
    patientName: updatedTags.find(tag => tag.tagID === "0010,0010")?.tagValue 
      ? updatedTags.find(tag => tag.tagID === "0010,0010")?.tagValue.replace(/\^/g, ' ')
      : originalPatientData.patientName.replace(/\^/g, ' '),
    study_desc: updatedTags.find(tag => tag.tagID === "0008,1030")?.tagValue
      ? updatedTags.find(tag => tag.tagID === "0008,1030")?.tagValue
      : originalPatientData.study_desc,
    ref_phy: updatedTags.find(tag => tag.tagID === "0008,0090")?.tagValue
      ? form.getValues().ref_phy
      : originalPatientData?.ref_phy?.replace(/\^/g, ' '),
    updatedTags: updatedTags,
    content: logContent
  }

  // Make the post to the backend
  postFetcher(study.tools.dicomEditWeblink, jsonParams)
    .then((response) => {
      // set Study method will update this studys row in the worklist with the updated information
      setStudy((study) => {
        return {
          ...study,
          study: {
            ...study.study,
            studyDescription: updatedTags?.find((tag) => tag.tagID === "0008,1030")?.tagValue?.length >= 0 && originalPatientData.study_desc != updatedTags.find((tag) => tag.tagID === "0008,1030").tagValue
              ? updatedTags?.find((tag) => tag.tagID === "0008,1030").tagValue
              : originalPatientData.study_desc,
          },
          physician: updatedTags?.find((tag) => tag.tagID === "0008,0090")?.tagValue?.length >= 0 && originalPatientData.ref_phy != updatedTags.find((tag) => tag.tagID === "0008,0090").tagValue
            ? updatedTags?.find((tag) => tag.tagID === "0008,0090")?.tagValue.replace(/\^/g, ' ')
            : study.physician,
          patient: {
            ...study.patient,
            patientID: updatedTags?.find((tag) => tag.tagID === "0010,0020")?.tagValue && originalPatientData.patientID != updatedTags.find((tag) => tag.tagID === "0010,0020").tagValue
              ? updatedTags?.find((tag) => tag.tagID === "0010,0020").tagValue
              : originalPatientData.patientID,
            patientName: updatedTags?.find((tag) => tag.tagID === "0010,0010")?.tagValue && originalPatientData.patientName != updatedTags.find((tag) => tag.tagID === "0010,0010").tagValue && updatedTags?.find((tag) => tag.tagID === "0010,0010")?.tagValue.length > 0 
              ? updatedTags?.find((tag) => tag.tagID === "0010,0010").tagValue
                .replace(/\^/g, ' ')
              : originalPatientData.patientName
                .replace(/\^/g, ' '),
            patientDOB: updatedTags?.find((tag) => tag.tagID === "0010,0030")?.tagValue?.length >= 0 && originalPatientData.patientDOB != updatedTags.find((tag) => tag.tagID === "0010,0030").tagValue && updatedTags?.find((tag) => tag.tagID === "0010,0030")?.tagValue.length >= 0 
              ? updatedTags?.find((tag) => tag.tagID === "0010,0030").tagValue 
              : originalPatientData.patientDOB,
          },
          institution: updatedTags?.find((tag) => tag.tagID === "0008,0080")?.tagValue?.length >= 0 && originalPatientData.institutionName != updatedTags.find((tag) => tag.tagID === "0008,0080").tagValue
            ? updatedTags?.find((tag) => tag.tagID === "0008,0080")?.tagValue 
            : study.institution,
        }
      })
      setIsSubmitting(false)
      setNotification("Values updated successfully.")
      closeDialog()
    })
    .catch((error) => {
      console.log("Failed to update values")
      setNotification({type:"alert",msg:<>Failed to update values.</>})
      setIsSubmitting(false)
    })
}

export const EditDicomDialog = ({study, setStudy, closeDialog}) => {
  const [,setNotification] = useNotificationRef()

  const [isLoading, setIsLoading] = useState(true)
  const [loadError, setLoadError] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [enableSubmit, setEnableSubmit] = useState(false)
  const [patientData, setPatientData] = useState({})
  const [originalPatientData, setOriginalPatientData] = useState({})
  const studyUid = study.tools.dicomEditWeblink.split("study_iuid=")[1]

  useEffect(() => {
  
    const getDicomTagsUrl = study.tools.dicomEditWeblink
    

    getFetcher(getDicomTagsUrl)
      .then((response) => {
        
        setOriginalPatientData(response)
        
        const nameObject = splitName(response.patientName)
        const newPatientData = {
          patientID: response.patientID,
          firstName: nameObject.firstName,
          middleName: nameObject.middleName,
          lastName: nameObject.lastName,
          patientSex: response.patientSex,
          institutionName: response.institutionName,
          // replace all ^ with spaces using regex
          ref_phy: response?.ref_phy?.replace(/\^/g, ' ')?.trim(),
          study_desc: response.study_desc,
          countStudies: response.countStudies,
        }
        
        if (response.patientDOB !== null){
          setPatientData({
            ...newPatientData,
            // patientDOB: new Date(
            //   response.patientDOB.substring(0, 4),
            //   response.patientDOB.substring(4, 6) - 1,
            //   response.patientDOB.substring(6, 8)
            // )
            patientDOB: new Date(
              Date.UTC(
                response.patientDOB.substring(0, 4),
                response.patientDOB.substring(4, 6) - 1,
                response.patientDOB.substring(6, 8)
              )
            )
          })
        }else{
          setPatientData(newPatientData)
        }
        setIsLoading(false)  
      })
      .catch((error) => {
        setLoadError(true)
        setIsLoading(false)
      });


  },[])

  if(isLoading) {
    return  <Dialog
        title="DICOM tag editor"
        closeDialog={closeDialog}
        footer={<>
          <Button onClick={closeDialog}>Cancel</Button>
        </>}
      >
        <LoadingDiv>
          <Loading size={40} borderWidth={6}/>
        </LoadingDiv>
      </Dialog>
  }

  if(loadError) {
    return <Dialog
            closeDialog={closeDialog}
            footer={<>
              <Button onClick={closeDialog}>Cancel</Button>
            </>}
          >
            <ErrorCard>
              <CardHeader>
                <h1>Something went wrong</h1>
              </CardHeader>
              <p><b>Please reload the page and try again.</b></p>
              <p>If the error persists please contact <a href="mailto:support@purview.net"
                                                        target="_blank">support@purview.net</a> or <span
                className="nowrap">call <b>+1 800-501-1537</b>.</span></p>
            </ErrorCard>
      </Dialog>
  }
  
  return <WithForm
    action={(values) => {
    }}
    // onSuccess={(values) => {
    // }}
    values={patientData}
    transform={(v) => transform(v, originalPatientData)}
    preValidation={preValidation}
  >{form =>
    <Dialog
      title="DICOM tag editor"
      closeDialog={closeDialog}
      footer={ () => {
        return <>
          <Button onClick={closeDialog}>Cancel</Button>
          <Button type="submit" highlight 
            disabled={!form.hasChanged && !enableSubmit}
            onClick={
              () => {
                form.willSubmitForm().then(() => {
                  setEnableSubmit(true)
                  updateAndClose(form, originalPatientData, studyUid, study, setStudy, closeDialog, setNotification, setIsSubmitting)
                })
              }
            }
            isLoading={isSubmitting}>
            Save
          </Button>
        </>}
      }
    >
      {/* {patientData.countStudies == 1 && (<InfoBox>
        Note: Any previously started or concluded report will <b>not</b> be automatically updated with changes made here.
      </InfoBox>)} */}
      <h3><b>Patient</b></h3>
      {patientData.countStudies > 1 && <TagEditorInfoBox>
        <b>There are {patientData.countStudies} studies linked to this patient.</b><br/>
        Updating patient's information will also update other linked studies.
      </TagEditorInfoBox>}
      <TextInput 
        label="Patient ID"
        path="patientID"
        value={study.patient.id}
        // descText={"Changing this value may affect log filtering for this patient."}
        mandatory
      ></TextInput>
      <FlexDiv>
        <TextInput 
          label="First Name"
          // path="patientName"
          path="firstName"
          // mandatory
          onInput={(e) => e.target.value = ("" + e.target.value).toUpperCase()}
        ></TextInput>
        <TextInput 
          label="Middle Name"
          path="middleName"
          onInput={(e) => e.target.value = ("" + e.target.value).toUpperCase()}
        ></TextInput>
        <TextInput 
          label="Last Name"
          path="lastName"
          // mandatory
          onInput={(e) => e.target.value = ("" + e.target.value).toUpperCase()}
        ></TextInput>
      </FlexDiv>
      <SplitColumnsContainer>
        <DatePicker label="Patient date of birth" path="patientDOB" format={DATE_FORMAT} />
        <RadioboxGroup path="patientSex" label="Gender" mandatory framedBoxes horizontal wide>
          <SimpleRadiobox label="Male"  fieldValue="M"/>
          <SimpleRadiobox label="Female" fieldValue="F"/>
        </RadioboxGroup>
      </SplitColumnsContainer>
      <hr css="margin:1rem 0 1.25rem;"/>
      <h3><b>Study</b></h3>
      {patientData.countStudies > 1 && <p css="margin-top:-0.5rem;font-size:12px!important;">
        Updating the fields below will affect only the selected study.
      </p>
      }
      <TextInput 
        label="Study description"
        path="study_desc"
        onInput={(e) => e.target.value = ("" + e.target.value).toUpperCase()}
      ></TextInput>
      <TextInput 
        label="Institution name"
        path="institutionName"
        onInput={(e) => e.target.value = ("" + e.target.value).toUpperCase()}
      ></TextInput>
      <TextInput 
        label="Referring physician name"
        path="ref_phy"
        onInput={(e) => e.target.value = ("" + e.target.value).toUpperCase()}
      ></TextInput>

      <Errors/>
    </Dialog>
  }</WithForm>
}

/*  DICOM PATIENT NAME REFERENCE

A character string encoded using a 5 component convention. The character code 5CH (the BACKSLASH "\" in ISO-IR 6) 
shall not be present, as it is used as the delimiter between values in multiple valued data elements. 
The string may be padded with trailing spaces. 
For human use, the five components in their order of occurrence are: 
family name complex, given name complex, middle name, name prefix, name suffix.

Note
HL7 prohibits leading spaces within a component; 
DICOM allows leading and trailing spaces and considers them insignificant.

Any of the five components may be an empty string. 
The component delimiter shall be the caret "^" character (5EH). 
Delimiters are required for interior null components. 
Trailing null components and their delimiters may be omitted. 
Multiple entries are permitted in each component and are encoded as natural text strings, 
in the format preferred by the named person.

For veterinary use, the first two of the five components in their order of occurrence are: 
responsible party family name or responsible organization name, patient name. 
The remaining components are not used and shall not be present.

https://dicom.nema.org/dicom/2013/output/chtml/part05/sect_6.2.html#sect_6.2.1.1

Rev. John Robert Quincy Adams, B.A. M.Div.
"Adams^John Robert Quincy^^Rev.^B.A. M.Div."
[One family name; three given names; no middle name; one prefix; two suffixes.]

Susan Morrison-Jones, Ph.D., Chief Executive Officer
"Morrison-Jones^Susan^^^Ph.D., Chief Executive Officer"
[Two family names; one given name; no middle name; no prefix; two suffixes.]

John Doe
"Doe^John"
[One family name; one given name; no middle name, prefix, or suffix. Delimiters have been omitted for the three trailing null components.]
(for examples of the encoding of Person Names using multi-byte character sets see Annex H)

"Smith^Fluffy"
[A cat, rather than a human, whose responsible party family name is Smith, and whose own name is Fluffy]

*/